<template>
  <div id="app">
    <div v-for="group in groups" :key="group.name">
      <h1>{{group.name}}</h1>
      <a  class="project" 
          v-for="project in group.links"  :key="project.name"
          :href="project.link" target="blank">
        {{project.name}}
        <br>
      </a><br>
    </div>
  </div>
</template>

<script>
let pdf_prefix = "http://docs.google.com/gview?embedded=true&url=";

/*
/////////PER I LINK DI TEORIA//////////
let list = [ "Angoli_2.pdf",
"Area_2.pdf",
"Cerchio_2.pdf",
"ComprensioneTesto_2a.pdf",
"ComprensioneTesto_2b.pdf",
"Fattorizzazione_2.pdf",
"Frazioni2_2.pdf",
"Frazioni_2.pdf",
"Misure_2.pdf",
"OperazioniAritmetiche2.pdf",
"OperazioniAritmetiche_2.pdf",
"PianoCartesiano_2.pdf",
"Proporzionalità_2.pdf",
"SolidiRotazione_2.pdf",
"Solidi_2.pdf",
"Statistica_2.pdf",
"TeoremaPitagora_2.pdf" ]
function getTitle(filename) {
    let str = filename.replace(/(.)([A-Z])/g, '$1 $2');
    str = str.substr(0, str.length-4);   
    str = str.replace('_', ' ');
    return str;
}
document.write(list.map(x=>`{ name: '${getTitle(x)}',link: pdf_prefix+'https://binario-934-csci.web.app/documents/${x}', }`));
*/

export default {
  name: 'App',
  components: {
  },
  data:()=>({
    groups: [
      {
        name: 'Teoria',
        links: [
          { name: 'Corso Scratch', link: 'https://drive.google.com/drive/folders/1cH9vG5f-uAwZYcvVbuTdHqMGAkTen-cP?usp=sharing', },
          { name: 'Angoli 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/Angoli_2.pdf', },
          { name: 'Area 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/Area_2.pdf', },
          { name: 'Cerchio 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/Cerchio_2.pdf', },
          { name: 'Comprensione Testo 2a',link: pdf_prefix+'https://binario-934-csci.web.app/documents/ComprensioneTesto_2a.pdf', },
          { name: 'Comprensione Testo 2b',link: pdf_prefix+'https://binario-934-csci.web.app/documents/ComprensioneTesto_2b.pdf', },
          { name: 'Fattorizzazione 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/Fattorizzazione_2.pdf', },
          { name: 'Frazioni2 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/Frazioni2_2.pdf', },
          { name: 'Frazioni 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/Frazioni_2.pdf', },
          { name: 'Misure 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/Misure_2.pdf', },
          { name: 'Operazioni Aritmetiche2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/OperazioniAritmetiche2.pdf', },
          { name: 'Operazioni Aritmetiche 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/OperazioniAritmetiche_2.pdf', },
          { name: 'Piano Cartesiano 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/PianoCartesiano_2.pdf', },
          { name: 'Proporzionalità 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/Proporzionalità_2.pdf', },
          { name: 'Solidi Rotazione 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/SolidiRotazione_2.pdf', },
          { name: 'Solidi 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/Solidi_2.pdf', },
          { name: 'Statistica 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/Statistica_2.pdf', },
          { name: 'Teorema Pitagora 2',link: pdf_prefix+'https://binario-934-csci.web.app/documents/TeoremaPitagora_2.pdf', }
        ]
      },
      {
        name: 'Angoli',
        links: [
          { name: 'angoli 2',link: "https://scratch.mit.edu/projects/420340862/", },
          { name: 'angoli 3', link: "https://scratch.mit.edu/projects/420342023/",},
        ]
      },
      {
        name: 'Perimetro',
        links: [
          { name: 'perimetro 1', link: "https://scratch.mit.edu/projects/420342307/", },
          { name: 'perimetro 3', link: "https://scratch.mit.edu/projects/420342592/"}
        ]
      },
      {
        name: 'Volumi',
        links: [
          {"name":"SolidiRotazione_3","link":"https://scratch.mit.edu/projects/420347585/"},
          {"name":"SolidiRotazione_2","link":"https://scratch.mit.edu/projects/420347520/"},
          {"name":"Solidi_3","link":"https://scratch.mit.edu/projects/420347461/"},
          {"name":"Solidi_2","link":"https://scratch.mit.edu/projects/420347362/"},
        ]
      },
      {
        name: 'Area Intermedio-alto',
        links: [
          {"name":"TeoremaPitagora_2","link":"https://scratch.mit.edu/projects/420347277/"},
          {"name":"Cerchio_2","link":"https://scratch.mit.edu/projects/420347216/"},
          {"name":"AreaAlto_3","link":"https://scratch.mit.edu/projects/420347159/"},
          {"name":"AreaAlto_1","link":"https://scratch.mit.edu/projects/420347002/"},
        ]
      },
      {
        name: 'Proporzionalità',
        links: [
          {"name":"Proporzionalità_3","link":"https://scratch.mit.edu/projects/420346813/"},
          {"name":"Proporzionalità_2","link":"https://scratch.mit.edu/projects/420346753/"},
          {"name":"Proporzionalità_1","link":"https://scratch.mit.edu/projects/420346602/"},
        ]
      },
      {
        name: 'Statistica',
        links: [
          {"name":"Statistica_3","link":"https://scratch.mit.edu/projects/420346398/"},
          {"name":"Statistica_2","link":"https://scratch.mit.edu/projects/420346342/"},
        ]
      },
      {
        name: 'Piano Cartesiano',
        links: [
          {"name":"PianoCartesiano_3","link":"https://scratch.mit.edu/projects/420346263/"},
          {"name":"PianoCartesiano_3 beta","link":"https://scratch.mit.edu/projects/420346206/"},
          {"name":"PianoCartesiano_2","link":"https://scratch.mit.edu/projects/420346129/"},
          {"name":"PianoCartesiano_1","link":"https://scratch.mit.edu/projects/420346074/"},
          {"name":"PianoCartesiano_1 beta","link":"https://scratch.mit.edu/projects/420346010/"},
        ]
      },
      {
        name: 'Area base-intermedio',
        links: [
          {"name":"Area_3","link":"https://scratch.mit.edu/projects/420345952/"},
          {"name":"Area_2","link":"https://scratch.mit.edu/projects/420345911/"},
          {"name":"Area_1","link":"https://scratch.mit.edu/projects/420345278/"},
        ]
      },
      {
        name: 'Comprensione del testo',
        links: [
          {"name":"ComprensioneTesto_3","link":"https://scratch.mit.edu/projects/420345127/"},
          {"name":"ComprensioneTesto_2b","link":"https://scratch.mit.edu/projects/420345057/"},
          {"name":"ComprensioneTesto_2a","link":"https://scratch.mit.edu/projects/420344888/"},
        ]
      },
      {
        name: 'Operazioni aritmetiche intermedio-alto',
        links: [
          {"name":"OperazioniAritmetiche2_3","link":"https://scratch.mit.edu/projects/420344536/"},
          {"name":"OperazioniAritmetiche2_2","link":"https://scratch.mit.edu/projects/420344482/"},
        ]
      },
      {
        name: 'Operazioni aritmetiche base-intermedio',
        links: [
          {"name":"OperazioniAritmetiche_3","link":"https://scratch.mit.edu/projects/420344384/"},
          {"name":"OperazioniAritmetiche_2","link":"https://scratch.mit.edu/projects/420344337/"},
          {"name":"OperazioniAritmetiche_1","link":"https://scratch.mit.edu/projects/420344265/"},
        ]
      },
      {
        name: 'Misure',
        links: [
          {"name":"Misure_3","link":"https://scratch.mit.edu/projects/420344127/"},
          {"name":"Misure_2","link":"https://scratch.mit.edu/projects/420344086/"},
          {"name":"Misure_1","link":"https://scratch.mit.edu/projects/420344019/"},
        ]
      },
      {
        name: 'Frazioni intermedio-alto',
        links: [
          {"name":"Frazioni2_2","link":"https://scratch.mit.edu/projects/420343915/"},
          {"name":"Frazioni2_1","link":"https://scratch.mit.edu/projects/420343640/"},
        ]
      },
      {
        name: 'Frazioni base-intermedio',
        links: [
          {"name":"Frazioni_2","link":"https://scratch.mit.edu/projects/420343526/"},
          {"name":"Frazioni_1","link":"https://scratch.mit.edu/projects/420343433/"},
          {"name":"Divisioni_2","link":"https://scratch.mit.edu/projects/420343212/"},
        ]
      },
      {
        name: 'Fattorizzazione',
        links: [
          {"name":"Fattorizzazione_3","link":"https://scratch.mit.edu/projects/420343086/"},
          {"name":"Fattorizzazione_2","link":"https://scratch.mit.edu/projects/420342879/"},
          {"name":"Fattorizzazione_1","link":"https://scratch.mit.edu/projects/420342720/"}
        ]
      }
    ]
  })
}
</script>

<style>
#app {
  font-family: sans-serif;
  padding: 30px;
}
.project {
  text-decoration: none;
  color: black;
  text-transform: capitalize;
  background-color: white;
  box-shadow: 0px 0px 10px lightgray; 
  border-radius: 10px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin: 10px;
}
</style>
